'use strict';
import { Infoblock } from './infoblock.js';

export class InfoblockHighlight extends Infoblock {
	
	constructor(component_id) {
		super(component_id);
		
		const backendData = yalwa.v.components[this.id].data;
		
		this.vue_data_vars = {
			maxAllowed: backendData.maxAllowed || 6,
			titleLimit: backendData.titleLimit,
			highlights: [],
			highlightsFromBE: structuredClone(backendData.highlights || []),
			showIconListWrapper: false,
			loading: false,
			selectedIndex: null,
			icons: backendData.icons
		};
		
		this.vue_method_vars = {
			
			initialize() {
				this.buildInitialState();
			},
			
			// ------------------------
			// Build initial state
			// ------------------------
			buildInitialState() {
				
				const persisted = this.highlightsFromBE.map(item => ({
					highlightID: item.highlightID || null,
					description: item.description || '',
					iconID: item.iconID || '',
					icon: item.icon_24 || '',
					isPersisted: true,
					_deleted: false // 👈 track deletion
				}));
				
				const emptySlots = Array.from(
					{ length: this.maxAllowed - persisted.length },
					() => this.emptyRow()
				);
				
				this.highlights = [...persisted, ...emptySlots];
			},
			
			emptyRow() {
				return {
					highlightID: null,
					description: '',
					iconID: '',
					icon: '',
					isPersisted: false,
					_deleted: false
				};
			},
			
			// ------------------------
			// Icon selection
			// ------------------------
			selectIcon(icon, iconID) {
				if (this.selectedIndex !== null) {
					this.highlights[this.selectedIndex].icon = icon;
					this.highlights[this.selectedIndex].iconID = iconID;
				}
				this.showIconListWrapper = false;
				this.selectedIndex = null;
			},
			
			showIconSelect(index) {
				this.selectedIndex = index;
				this.showIconListWrapper = true;
			},
			
			// ------------------------
			// Delete (LOCAL ONLY)
			// ------------------------
			deleteRecord(highlightID = 0, index = -1) {
				
				// New (unsaved row)
				if (index >= 0) {
					this.highlights[index] = this.emptyRow();
					return;
				}
				
				// Persisted item → mark as deleted
				const itemIndex = this.highlights.findIndex(
					h => h.highlightID === highlightID
				);
				
				if (itemIndex !== -1) {
					this.highlights[itemIndex]._deleted = true;
				}
			},
			
			// ------------------------
			// Save (ONLY PLACE WITH API)
			// ------------------------
			saveIconBoxData() {
				this.is_saving = true;
				
				const cleaned = this.highlights.map(item => {
					
					// Handle deleted items
					if (item._deleted && item.highlightID) {
						return {
							highlightID: item.highlightID,
							deleted: true
						};
					}
					
					// Handle add/update
					if (item.description?.trim() || item.iconID) {
						return {
							highlightID: item.highlightID,
							description: item.description.trim(),
							iconID: item.iconID
						};
					}
					
					return null;
					
				}).filter(Boolean);
				
				yalwa.basics.ajaxservice({
					type: 'POST',
					resource: 'profileupdate',
					action: 'update_highlights',
					data: {
						data: JSON.stringify(cleaned)
					},
					include_session: true
				}).then(response => {
					
					if (response.type === 'success') {
						if (response.vip_completion) {
							document.dispatchEvent(new CustomEvent('vip_guide_state', {detail: response.vip_completion}));
						}
						this.highlightsFromBE = structuredClone(response.highlights || []);
						this.buildInitialState();
						this.close();
					}
					
					yalwa.basics.toast({
						message: response.label,
						type: response.type
					});
					
				}).finally(() => {
					this.is_saving = false;
				});
			},
			close() {
				this.resetLocalWorkingCopy();
			},
			resetLocalWorkingCopy() {
				// Reset local working copy from backend
				this.highlights = [];
				this.buildInitialState();
				
				// Reset UI states
				this.showIconListWrapper = false;
				this.selectedIndex = null;
				
				this.closeDialog();
			}
		};
		
		this.extras = {
			computed: {
				
				// ------------------------
				// Save button control
				// ------------------------
				isUnchanged() {
					
					const normalize = (list) => {
						return (Array.isArray(list) ? list : [])
							.map(item => ({
								id: item.highlightID || null,
								desc: (item.description || '').trim(),
								icon: item.iconID || '',
								deleted: item._deleted || false
							}))
							// remove completely empty rows
							.filter(item => item.desc !== '' || item.icon !== '' || item.deleted)
							// sort for stable comparison
							.sort((a, b) => (a.id || 0) - (b.id || 0));
					};
					
					const current = normalize(this.highlights);
					const backend = normalize(this.highlightsFromBE);
					
					return JSON.stringify(current) !== JSON.stringify(backend);
				}
			},
			
			mounted() {
				this.initialize();
			}
		};
	}
	
	setup_vars(Vue) {}
}